'use strict';

var $                   = require('jquery');
var Core                = require('../core/core.js');

/**
 * Creates a Tab
 *
 * @class
 */

class ModalListSelectItem extends Core {

    _defaults() {
        return {
            target: '.js-modal',
            fields: {
                'item': ''
            }
        };
    }

    constructor(options) {
        super(options);

        this.template = `
            <div class='editor__modal__list__select__item'>` + options.fields.item
                + `<% if (item) { %>
                    <a class='btn btn--m btn--accent_none_accent btn--select'><div class='btn__txt'>Select</div></a>
                <% } %>
            </div>
        `;

        super.render();

        $('.btn--select', this.$el).on('click', this._clicked.bind(this));
    }

    /**
     * @event Modal#Cioui:ModalListItemSelectButton:clicked
     * @property {String}Cioui:ModalListItemSelectButton:clicked
     * @returns {Object} event - native click Event
     */

    _clicked(e){
        e.preventDefault();
        this.$el.trigger('Cioui:Modal:ModalListItemSelectButton:clicked', e);
    }
}

module.exports = ModalListSelectItem;